import type { ContextState, Plugin } from '@tinkoff/request-core';

interface ErrorFormatter {
  (state: ContextState): Error | undefined;
}

interface Options {
  errorFormatter: ErrorFormatter;
}

export default function formatErrorPlugin({ errorFormatter }: Options): Plugin {
  return {
    error: (context, next) => {
      const state = context.getState();
      const newError = errorFormatter(state);

      if (newError) {
        return next({ error: newError });
      }

      return next();
    },
  };
}
